import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AppService } from "src/app/app.service";
import { Global } from "../../../global";
import { PagesLoadedEvent, PageRenderedEvent } from "ngx-extended-pdf-viewer";

@Component({
  selector: "app-procedure-modal",
  templateUrl: "procedure-modal.page.html",
  styleUrls: ["procedure-modal.page.scss"],
})
export class ProcedureModalPage implements OnInit {
  Content_GUID: any;
  ContentViewing: any;
  modalHeaderText: any;
  must_accept: boolean;
  must_captcha: boolean;
  must_sign: boolean;
  must_UploadSignedDocument: boolean;

  PDFLocation: string;
  TotalPages: number;
  CurrentPage: number;
  allRed: boolean = false;
  public zoom = "100%";

  procedureForm: any;
  private procedure: any;

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    private formBuilder: FormBuilder,
    private appservice: AppService,
    public globals: Global
  ) {
    this.procedureForm = this.formBuilder.group({
      fc_AcceptDocument: [""],
      fc_Captcha: [""],
      fc_Sign: [""],
      fc_UploadSignedDocument: [""],
    });
  }

  ngOnInit() {
    console.table(this.navParams);
    // this.modelId = this.navParams.data.paramID;
    // this.modalTitle = this.navParams.data.paramTitle;
    this.procedure = this.createEmptyProcedure();
    this.Content_GUID = this.navParams.data.paramObject.Content_GUID;
    this.modalHeaderText = this.navParams.data.paramObject.modalHeaderText;
    this.must_accept = this.navParams.data.paramObject.must_accept;
    this.must_captcha = this.navParams.data.paramObject.must_captcha;
    this.must_sign = this.navParams.data.paramObject.must_sign;
    this.must_UploadSignedDocument =
      this.navParams.data.paramObject.must_UploadSignedDocument;

    this.displayContent(this.Content_GUID);

    if (this.must_accept == true) {
      this.procedureForm
        .get("fc_AcceptDocument")
        .setValidators([Validators.required]);
      this.procedureForm.get("fc_AcceptDocument").updateValueAndValidity();
    }
    if (this.must_captcha == true) {
      this.procedureForm.get("fc_Captcha").setValidators([Validators.required]);
      this.procedureForm.get("fc_Captcha").updateValueAndValidity();
    }
    if (this.must_sign == true) {
      this.procedureForm.get("fc_Sign").setValidators([Validators.required]);
      this.procedureForm.get("fc_Sign").updateValueAndValidity();
    }
    if (this.must_sign == true) {
      this.procedureForm
        .get("fc_UploadSignedDocument")
        .setValidators([Validators.required]);
      this.procedureForm
        .get("fc_UploadSignedDocument")
        .updateValueAndValidity();
    }
  }

  createEmptyProcedure() {
    var procedure = {
      AcceptedDocument: false,
      Captcha: false,
      Signed: false,
      UploadSignedDocument: false,
    };
    return procedure;
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control: any) => {
      if (control instanceof FormControl) {
        control.markAsTouched();
        control.updateValueAndValidity();
      } else if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  markFormGroupUnTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control: any) => {
      if (control instanceof FormControl) {
        control.markAsUntouched();
      } else if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  displayContent(Content_GUID: string) {
    var formData = new FormData();
    formData.append("Content_GUID", Content_GUID);

    this.appservice.GetContentDetail(formData).subscribe((res) => {
      try {
        this.ContentViewing = JSON.parse(res.toString());
        this.ContentViewing.url =
          this.globals.XRSBaseURLWebLMS + this.ContentViewing.Location;
        this.PDFLocation = this.ContentViewing.url;
      } catch (e) { }
    });
  }

  async closeModal() {
    await this.modalController.dismiss(this.procedure);
  }

  async onCloseUpload() {
    await this.modalController.dismiss(this.procedure);
  }

  public onPagesLoaded(pagecount: PagesLoadedEvent): void {
    this.TotalPages = pagecount.pagesCount;
  }

  public onPageRendered(pageRendered: PageRenderedEvent): void {
    this.CurrentPage = pageRendered.pageNumber;
  }
}
